export default __webpack_public_path__ + "static/study-febrile-0ac9635a34b32043948ba4354082e578.svg";